import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
import { CTAButton } from './CTAButton';
const tomos = [{
  icon: '🔵',
  title: 'Tomo 1 — Planificación Anual Completa',
  subtitle: 'Organiza todo tu año escolar con claridad',
  accent: 'border-l-blue-500',
  items: ['Visión general del año escolar', 'Distribución de contenidos por periodo', 'Calendario académico estructurado', 'Metas y objetivos claros', 'Organización por áreas curriculares', 'Base sólida para todo el año']
}, {
  icon: '🟢',
  title: 'Tomo 2 — Planificación Mensual y Semanal',
  subtitle: 'Baja tu planificación a la práctica real',
  accent: 'border-l-green-500',
  items: ['Planificación mensual estructurada', 'Organización semanal paso a paso', 'Distribución de actividades', 'Seguimiento de avances', 'Ajustes y flexibilidad', 'De lo general a lo específico']
}, {
  icon: '🟡',
  title: 'Tomo 3 — Sesiones de Clase por Área',
  subtitle: 'Estructura tus clases con más orden y seguridad',
  accent: 'border-l-yellow-400',
  items: ['Sesiones listas por área curricular', 'Inicio – Desarrollo – Cierre', 'Actividades secuenciadas', 'Recursos sugeridos', 'Adaptable a tu contexto', 'Clases con estructura clara']
}, {
  icon: '🟣',
  title: 'Tomo 4 — Proyectos y Actividades',
  subtitle: 'Haz tus clases más dinámicas y participativas',
  accent: 'border-l-purple-500',
  items: ['Proyectos listos para aplicar', 'Actividades por competencia', 'Dinámicas grupales', 'Aprendizaje activo', 'Participación estudiantil', 'Experiencias significativas']
}, {
  icon: '🔴',
  title: 'Tomo 5 — Evaluación y Registros',
  subtitle: 'Evalúa mejor y lleva seguimiento sin complicarte',
  accent: 'border-l-red-500',
  items: ['Instrumentos de evaluación', 'Registros de seguimiento', 'Rúbricas y listas de cotejo', 'Informes de progreso', 'Evaluación formativa', 'Todo organizado y listo']
}, {
  icon: '🟤',
  title: 'Tomo 6 — Formatos y Documentos Editables',
  subtitle: 'Ten a la mano los documentos clave de tu trabajo docente',
  accent: 'border-l-amber-800',
  items: ['Formatos administrativos', 'Documentos editables', 'Plantillas reutilizables', 'Informes y reportes', 'Actas y registros', 'Todo en un solo lugar']
}];
const features = ['Actividades y estructuras listas para adaptar', 'Organización paso a paso', 'Recursos prácticos', 'Plantillas imprimibles', 'Aplicación inmediata en tu trabajo docente'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-297">
      <div className="max-w-xl mx-auto" data-id="element-298">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-3" data-id="element-299">
          📚 LO QUE RECIBES
        </h2>
        <p className="text-center text-gray-400 text-sm mb-8" data-id="element-300">
          6 tomos completos listos para usar
        </p>

        <div className="space-y-3 mb-10" data-id="element-301">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-gray-900 border border-gray-800 border-l-4 ${tomo.accent} rounded-lg overflow-hidden`} data-id="element-302">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-4 flex items-start gap-3 text-left" data-id="element-303">
                  <span className="text-2xl flex-shrink-0" data-id="element-304">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-305">
                    <h3 className="text-sm font-bold text-white mb-0.5" data-id="element-306">
                      {tomo.title}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-307">{tomo.subtitle}</p>
                  </div>
                  {isOpen ? <ChevronUp size={18} className="text-brand-yellow flex-shrink-0 mt-1" data-id="element-308" /> : <ChevronDown size={18} className="text-gray-600 flex-shrink-0 mt-1" data-id="element-309" />}
                </button>
                {isOpen && <div className="px-4 pb-4 pl-12" data-id="element-310">
                    <div className="space-y-2" data-id="element-311">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-312">
                          <CheckCircle2 className="text-green-500 flex-shrink-0" size={14} data-id="element-313" />
                          <span className="text-xs text-gray-400" data-id="element-314">{item}</span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 mb-10" data-id="element-315">
          <h3 className="text-base font-bold text-center text-brand-yellow mb-4" data-id="element-316">
            ✨ Cada tomo incluye:
          </h3>
          <div className="space-y-3" data-id="element-317">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-318">
                <CheckCircle2 className="text-green-500 flex-shrink-0" size={18} data-id="element-319" />
                <span className="text-sm text-gray-300 font-medium" data-id="element-320">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>

        
      </div>
    </section>;
}